import React from 'react';
import { CarIcon, UserIcon } from 'lucide-react';
import { useApp } from '../context/AppContext';
export const DriverToggle: React.FC = () => {
  const {
    isDriverMode,
    setIsDriverMode
  } = useApp();
  return <button onClick={() => setIsDriverMode(!isDriverMode)} className="flex items-center bg-card border border-primary border-opacity-30 rounded-full px-3 py-2" data-id="element-54">
      {isDriverMode ? <>
          <CarIcon size={16} className="text-primary mr-2" data-id="element-55" />
          <span className="text-xs text-primary font-medium" data-id="element-56">Driver</span>
        </> : <>
          <UserIcon size={16} className="text-white text-opacity-70 mr-2" data-id="element-57" />
          <span className="text-xs text-white text-opacity-70" data-id="element-58">Passenger</span>
        </>}
    </button>;
};